import stockAPI from "@/utility/api.js";

export default {
  createDescription(content ,formData) {
    return stockAPI.POST("api/descriptions", formData);
  },
	async fetchDescriptions({ commit }, page) {
		const res = await stockAPI.GET(
      `api/descriptions?page=${page}`
    );
		commit("descriptionsData", res);
		return Promise.resolve();
	},
	deleteADescription(content, selectedList) {
		return stockAPI.DELETE(`api/descriptions`, selectedList);
	},
	async fetchOneDescription({ commit }, id) {
    const res = await stockAPI.GET(`api/descriptions/${id}`);
		commit("oneDescription", res);
		return Promise.resolve();
	},
	updateOneDescription({ getters }, formData) {
    return stockAPI.PUT(
      `api/descriptions/${getters.oneDescription.id}`,
      formData
    );
  }
};
